/* eslint-disable @typescript-eslint/no-explicit-any */
import { lazy, Suspense } from 'react';
import Protected from 'components/auth/Protected';
import apiEndpoints from 'constants/apiEndpoints';
import { RouteObject } from 'react-router-dom';
import { vehicleUpdateLocation } from 'loaders/vehicleUpdateLocation';
import { commonLoader } from 'loaders/commonLoader';
const VehicleList = lazy(
  () => import('pages/vehicle/vehicle-list/VehicleList')
);
const CreateVehiclePage = lazy(() => import('pages/vehicle/CreateVehiclePage'));

export function SuspenseWrapper({ children }: { children: any }) {
  return <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>;
}

const vehicleRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <Protected action="view" module={'Vehicle'}>
        <SuspenseWrapper>
          <VehicleList />
        </SuspenseWrapper>
      </Protected>
    )
  },
  {
    path: 'detail/:id',
    element: (
      <Protected action="view" module={'Vehicle'}>
        <SuspenseWrapper>
          <CreateVehiclePage isUpdate={true} />
        </SuspenseWrapper>
      </Protected>
    ),
    loader: ({ params }) =>
      commonLoader({
        params,
        apiEndpoints: apiEndpoints.vehicle.getDetail
      })
  },
  {
    path: 'new',
    element: (
      <Protected action="maker" module={'Vehicle'}>
        <SuspenseWrapper>
          <CreateVehiclePage isUpdate={false} />
        </SuspenseWrapper>
      </Protected>
    )
  },
  {
    path: 'update/:id',
    element: (
      <Protected action="edit" module={'Vehicle'}>
        <SuspenseWrapper>
          <CreateVehiclePage isUpdate={true} />
        </SuspenseWrapper>
      </Protected>
    ),
    loader: vehicleUpdateLocation
  }
];

export default vehicleRoutes;
